import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'
import './checks.scss'

const CheckCdn = ({ cdnCheck, level = 0 }) => {
  const { t } = useTranslation(['common', 'messages'])

  const certidao = cdnCheck?.checkDetails?.Certidao ?? {}
  const hasChecks = !cdnCheck?.checkDetails?.Mensagem.includes('Certidão Não Emitida')

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:negativeDebtCertificate')}</Typography>
        <CheckRiskStatus checkLength={hasChecks ? 1 : 0} hasChecks={hasChecks} />
      </Paper>

      <CheckDetailTitle
        email={cdnCheck?.email}
        status={cdnCheck?.status}
        createdAt={cdnCheck?.createdAt}
        updatedAt={cdnCheck?.updatedAt}
      />

      {!hasChecks && (
        <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
          <Typography variant="subtitle3">
            {cdnCheck?.checkDetails?.Mensagem || t('messages:noDataCheckAvailable')}
          </Typography>
        </Paper>
      )}

      {hasChecks && (
        <TimelineDotLine>
          <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
            <div className="c-detail-grid">
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:message')}</Typography>
                <Typography variant="subtitle3">{cdnCheck?.checkDetails?.Mensagem ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:taxpayerType')}</Typography>
                <Typography variant="subtitle3">{certidao?.TipoContribuinte ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:taxpayerCertificate')}</Typography>
                <Typography variant="subtitle3">{certidao?.ContribuinteCertidao ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:certificateType')}</Typography>
                <Typography variant="subtitle3">{certidao?.TipoCertidao ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:controlCode')}</Typography>
                <Typography variant="subtitle3">{certidao?.CodigoControle ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:issuanceDate')}</Typography>
                <Typography variant="subtitle3">{certidao?.DataEmissao ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:expirationDate')}</Typography>
                <Typography variant="subtitle3">{certidao?.DataValidade ?? '---'}</Typography>
              </div>
            </div>
          </Paper>
        </TimelineDotLine>
      )}
    </>
  )
}

export default CheckCdn

/* import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'

const variantByLevel = {
  0: 'h3',
  1: 'h4',
}

const CheckCdn = ({ title = '', cdnCheck, level = 0 }) => {
  const { t } = useTranslation(['common', 'messages'])
  return (
    <Box className="detail-group">
      <Typography variant={variantByLevel[level] || variantByLevel[0]}>
        {title || t('common:negativeDebtCertificate')}
      </Typography>
      <CheckDetailTitle
        email={cdnCheck.email}
        status={cdnCheck.status}
        createdAt={cdnCheck.createdAt}
        updatedAt={cdnCheck.updatedAt}
      />
      <Box className="">
        <h4>
          {t('common:negativeDebtCertificate')} {t('common:details')}
        </h4>
        <Box className="detail-group-grid-4">
          <Box>
            <span>{t('common:message')}</span>
            <p>{cdnCheck?.checkDetails?.Mensagem ?? '---'}</p>
          </Box>
          <Box>
            <span>{t('common:taxpayerType')}</span>
            <p>{cdnCheck?.checkDetails?.Certidao?.TipoContribuinte ?? '---'}</p>
          </Box>
          <Box>
            <span>{t('common:taxpayerCertificate')}</span>
            <p>{cdnCheck?.checkDetails?.Certidao?.ContribuinteCertidao ?? '---'}</p>
          </Box>
          <Box>
            <span>{t('common:certificateType')}</span>
            <p>{cdnCheck?.checkDetails?.Certidao?.TipoCertidao ?? '---'}</p>
          </Box>
          <Box>
            <span>{t('common:controlCode')}</span>
            <p>{cdnCheck?.checkDetails?.Certidao?.CodigoControle ?? '---'}</p>
          </Box>
          <Box>
            <span>{t('common:issuanceDate')}</span>
            <p>{cdnCheck?.checkDetails?.Certidao?.DataEmissao ?? '---'}</p>
          </Box>
          <Box>
            <span>{t('common:expirationDate')}</span>
            <p>{cdnCheck?.checkDetails?.Certidao?.DataValidade ?? '---'}</p>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default CheckCdn
 */
